// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
import { membershipEpochGuard } from './../foundations/index.js';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    organizationId: z.string().min(1).max(21),
    userId: z.string().min(1).max(128),
    membershipEpoch: membershipEpochGuard.optional(),
    directoryActive: z.boolean().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    organizationId: z.string().min(1).max(21),
    userId: z.string().min(1).max(128),
    membershipEpoch: membershipEpochGuard,
    directoryActive: z.boolean(),
});
export const OrganizationMembershipEpochs = Object.freeze({
    table: 'organization_membership_epochs',
    tableSingular: 'organization_membership_epoch',
    fields: {
        tenantId: 'tenant_id',
        organizationId: 'organization_id',
        userId: 'user_id',
        membershipEpoch: 'membership_epoch',
        directoryActive: 'directory_active',
    },
    fieldKeys: [
        'tenantId',
        'organizationId',
        'userId',
        'membershipEpoch',
        'directoryActive',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
